var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(18 13 30) translate(0 8)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 5.5,
  width: 4.6,
  height: 13,
  rx: 2,
  fill: "#8a5a33"
}), /*#__PURE__*/React.createElement("rect", {
  x: 10.2,
  y: 18,
  width: 6.2,
  height: 4.2,
  rx: 1,
  fill: "#9aa7b0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.6 22.2h5.4v6.2c0 1.5-1.2 2.7-2.7 2.7s-2.7-1.2-2.7-2.7z",
  fill: "#efe6d4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.6 27h5.4v1.4c0 1.5-1.2 2.7-2.7 2.7s-2.7-1.2-2.7-2.7z",
  fill: "#7fae62"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m24.5 21.5h14.5v16c0 1.1-0.9 2-2 2h-10.5c-1.1 0-2-0.9-2-2z",
  fill: "#9aa7b0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m25.5 21c2-4.5 10.5-4.5 12.5 0",
  fill: "none",
  stroke: "#5f6d77",
  strokeWidth: 1.6,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 23.2,
  y: 19.4,
  width: 17.1,
  height: 3.4,
  rx: 1.7,
  fill: "#5f6d77"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m24.2 22.8h15.1c-0.3 1.3-1.6 1.6-2.6 2.9-0.6 0.8 0.1 2.9-1.3 3.4-1.3 0.5-1.9-1.5-3.4-1.5s-2.3 1.2-3.7 0.9c-1.3-0.3-0.8-2-1.7-2.8-1-0.9-2.4-1.4-2.4-2.9z",
  fill: "#7fae62"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m35.2 26.4c0 0 1.1 2.6 1.1 3.7 0 0.7-0.5 1.2-1.1 1.2s-1.1-0.5-1.1-1.2c0-1.1 1.1-3.7 1.1-3.7z",
  fill: "#7fae62"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 26.5,
  y: 31.5,
  width: 10.5,
  height: 3.6,
  rx: 1,
  fill: "#efe6d4"
});

function SvgPaintBrushCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBrushCan);
export default __webpack_public_path__ + "static/media/paint-brush-can.69f97e67dd5164427fdcb7b5292545a7.svg";
export { ForwardRef as ReactComponent };